export default function nonNullable(value) {
  return value !== null && value !== undefined;
}